import { ArtifactKind, ArtifactSummary } from '../../forgeApi.types'

export interface GetArtifactsResponse {
  artifacts?: ArtifactSummary[]
}

export interface GetArtifactsParams {
  kind?: ArtifactKind
  category_id?: string
}
